// extracted by mini-css-extract-plugin
module.exports = {"container":"CardBrandList_container__YEanm","logo_wrapper":"CardBrandList_logo_wrapper__lID1X"};